import React, { useEffect } from 'react';
import Index from './pages/Index';

import "./assets/css/style.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";

function App() {

  useEffect(() => {

    const runWhenIdle = (callback) => {
      if ("requestIdleCallback" in window) {
        const idleId = window.requestIdleCallback(callback, { timeout: 6000 });
        return () => window.cancelIdleCallback(idleId);
      }

      const timerId = window.setTimeout(callback, 6000);
      return () => window.clearTimeout(timerId);
    };

    let cancelled = false;

    const cancelIdleTask = runWhenIdle(async () => {
      if (cancelled || !("Notification" in window)) return;

      try {
        const { requestForToken, onMessageListener } = await import("./utils/firebaseNotification");

        if (cancelled) return;

        if (Notification.permission === "granted") {
          requestForToken().then((token) => {

            if (token) {
              console.log("FCM TOKEN:", token);
            }

          });
        }

        onMessageListener()
          .then((payload) => {

            console.log("Foreground Message:", payload);

          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    });

    return () => {
      cancelled = true;
      cancelIdleTask();
    };

  }, []);

  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
